import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { API } from "aws-amplify";

@Component({
    selector: "app-redirect-stripe",
    templateUrl: "./redirect-stripe.component.html",
    styleUrls: ["./redirect-stripe.component.scss"],
})
export class RedirectStripeComponent implements OnInit {
    accountID: string;

    loading = true;

    code: string;

    orgID: string;

    constructor(private route: ActivatedRoute, private router: Router) { }

    ngOnInit() {
        this.route.params.subscribe((parameters) => {
            this.accountID = parameters.id;
        });
        this.route.queryParams.subscribe((queryParameters) => {
            if (queryParameters && queryParameters.code) {
                this.code = queryParameters.code;
            }
            if (queryParameters && queryParameters.state) {
                this.orgID = queryParameters.state;
            }
        });
        if (!this.accountID && !this.code) {
            this.rollback();
        } else if (this.accountID) {
            this.redirect();
        }
        if (this.orgID && this.code) {
            // console.log(this.code);
            this.getOAuthToken();
        }
    }

    async redirect() {
        const body = {
            accountID: this.accountID,
            origin,
        };
        const responseAccountLinks = await API.post(
            "stripeApi",
            "/onboard-user/refresh",
            { body },
        );
        if (responseAccountLinks.error) {
            alert(responseAccountLinks.error);
            this.loading = false;
            this.rollback();
            return;
        }
        window.location.href = responseAccountLinks.accountLinks.url;
    }

    rollback() {
        this.router.navigate(["dashboard/hotel"]);
    }

    async getOAuthToken() {
        if (!this.orgID || !this.code) {
            return;
        }
        const body = {
            orgID: this.orgID,
            grant_type: "authorization_code",
            code: this.code,
        };
        const response = await API.post("stripeApi", "/token", { body });
        if (response.err) {
            alert(response.err.raw.message);
        }
        this.loading = false;
        this.rollback();
    }
}
